/**
 * @author LB
 * @description 未登录状态查看页面
 */
export default [
  {
    path: '/view/viewReport/:reportId',
    name: 'view_viewReport',
    meta: {
      viewTitle: '嗨探',
      title: '查看报告',
      view: true,
      pageId: 'viewReport',
      pageName: '查看报告',
      parentId: 'view',
      parentName: '其它功能',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/viewReport/viewReport'], resolve),
  },
  {
    path: '/view/viewAudio/:reportId/:historyReportId?',
    name: 'view_viewAudio',
    meta: {
      viewTitle: '嗨探',
      title: '报告录音',
      view: false,
      pageId: 'viewAudio',
      pageName: '报告录音',
      parentId: 'view',
      parentName: '其它功能',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/viewReport/viewAudio'], resolve),
  },
  {
    path: '/view/helpCenter',
    name: 'view_helpCenter',
    meta: {
      title: '帮助中心',
      view: true,
      pageId: 'helpCenter',
      pageName: '帮助中心',
      parentId: 'view',
      parentName: '其它功能',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/help/helpCenter'], resolve),
  },
  {
    path: '/view/visitorCommitment',
    name: 'view_visitorCommitment',
    meta: {
      title: '用户承诺书',
      view: true,
      pageId: 'visitorCommitment',
      pageName: '用户承诺书',
      parentId: 'view',
      parentName: '其它功能',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/user/visitorUser/visitorCommitment'], resolve),
  },
  {
    path: '/view/customerService',
    name: 'view_customerService',
    meta: {
      viewTitle: '嗨探客服',
      title: '嗨探客服',
      view: false,
      pageId: 'customerService',
      pageName: '嗨探客服',
      parentId: 'view',
      parentName: '其它功能',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/help/customerService'], resolve),
  },
  {
    path: '/view/reportCompare',
    name: 'view_reportCompare',
    meta: {
      viewTitle: '报告比对',
      title: '报告比对',
      view: true,
      pageId: 'reportCompare',
      pageName: '报告比对',
      parentId: 'view',
      parentName: '其它功能',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/operation/reportManage/reportCompare'], resolve),
  },
  {
    path: '/view/test',
    name: 'view_test',
    meta: {
      viewTitle: '测试',
      title: '测试',
      view: true,
    },
    component: resolve => require(['@/views/viewReport/test'], resolve),
  },
];
